import * as React from 'react';
import i18n from 'src/resources/i18n';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import QuickModeStudentAssign from '../../containers/QuickModeStudentAssign';

/**
 * コンテンツ配信画面
 * @param props
 */
const StudentAssign: React.FunctionComponent<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Rakunavi_Name')} />
			<QuickModeStudentAssign {...props} />
		</>
	);
};

export default StudentAssign;



// WEBPACK FOOTER //
// ./src/pages/quickMode/StudentAssign.tsx